module.exports = __webpack_public_path__ + "img/xarths2.9b5414e7.png";